import { connect } from 'react-redux'
import { compose } from 'redux'
import withType from 'components/common/hoc/withType'
import { showModal } from './actions'
import HeaderSearch from './HeaderSearch'

export default compose(
  withType({ type: 'HeaderSearch' }),
  connect(null, { showModal })
)(HeaderSearch)
